module.exports = __webpack_public_path__ + "static/media/logo-itau.534d0cd7.svg";